import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { mediaUrl } from "../../lib/api";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/news", label: "News" },
  { to: "/events", label: "Events" },
  { to: "/players", label: "Players" },
  { to: "/achievements", label: "Achievements" },
  { to: "/gallery", label: "Gallery" },
  { to: "/office-bearers", label: "Office Bearers" },
  { to: "/contact", label: "Contact" },
];

export const Logo = ({ light = false }) => {
  const { settings } = useSite();
  return (
    <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
      {settings?.logo ? (
        <img src={mediaUrl(settings.logo)} alt="TDBA logo" className="h-11 w-11 rounded-full object-cover" />
      ) : (
        <span className="h-11 w-11 rounded-full bg-[#0B1F44] text-white grid place-items-center font-display font-extrabold text-sm ring-2 ring-blue-500/30">TDBA</span>
      )}
      <span className="leading-tight">
        <span className={`block font-display font-bold text-[15px] ${light ? "text-white" : "text-[#0B1F44]"}`}>TDBA</span>
        <span className={`block text-xs ${light ? "text-slate-300" : "text-slate-500"}`}>Thanjavur District Badminton Association</span>
      </span>
    </Link>
  );
};

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();
  useEffect(() => setOpen(false), [loc.pathname]);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);
  const linkCls = ({ isActive }) =>
    `px-3 py-2 rounded-full text-sm font-medium transition-colors ${isActive ? "text-blue-700 bg-blue-50" : "text-slate-600 hover:text-[#0B1F44] hover:bg-slate-100"}`;
  return (
    <header className={`fixed top-0 inset-x-0 z-50 bg-white/90 backdrop-blur-md border-b transition-shadow ${scrolled ? "shadow-sm border-slate-200" : "border-transparent"}`} data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Logo />
        <nav className="hidden xl:flex items-center gap-1">
          {NAV_LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} className={linkCls} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>{l.label}</NavLink>
          ))}
          <Link to="/contact" className="ml-3 btn-primary text-sm" data-testid="nav-contact-cta">Contact TDBA</Link>
        </nav>
        <button className="xl:hidden p-2 rounded-lg hover:bg-slate-100" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <nav className="xl:hidden border-t border-slate-200 bg-white px-4 py-4 flex flex-col gap-1 animate-fade-in" data-testid="nav-mobile-menu">
          {NAV_LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} className={linkCls} data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>{l.label}</NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
